module.exports = __webpack_public_path__ + "img/logo_w.25c31d75.png";